/* Blue Master quantity cards: mirror Shopify's native quantity rules and cart state. */
(function () {
  'use strict';
  if (window.__swQuantityOffersV4) return;
  window.__swQuantityOffersV4 = true;

  const groupSelector = '.sw-quantity-offers';
  const inputSelector = 'quantity-selector-component input[name="quantity"]';

  function quantityInput(group) {
    return group.closest('form')?.querySelector(inputSelector) || null;
  }

  function constraints(group, input) {
    const minimum = Number(input.min) || 1;
    const increment = Number(input.step) || 1;
    const inCart = Number(input.dataset.cartQuantity) || 0;
    const nativeLimit = input.max ? Number(input.max) : Infinity;
    const totalLimit = group.dataset.maxTotal ? Number(group.dataset.maxTotal) : Infinity;
    // Both limits are total variant quantities. Deduct the latest cart quantity ONCE.
    const maxAdd = Math.min(nativeLimit, totalLimit) - inCart;
    return { minimum, increment, maxAdd };
  }

  function refresh(group, input) {
    const { minimum, increment, maxAdd } = constraints(group, input);
    const current = Number(input.value);
    group.querySelectorAll('button[data-sw-quantity]').forEach(button => {
      const amount = Number(button.dataset.swQuantity);
      const allowed =
        group.dataset.swAvailable === 'true' &&
        !input.disabled &&
        Number.isInteger(amount) &&
        amount >= minimum &&
        (amount - minimum) % increment === 0 &&
        amount <= maxAdd;
      button.disabled = !allowed;
      button.setAttribute('aria-disabled', String(!allowed));
      button.setAttribute('aria-pressed', String(allowed && amount === current));
    });
  }

  function refreshAll(scope) {
    scope.querySelectorAll(groupSelector).forEach(group => {
      const input = quantityInput(group);
      if (input) refresh(group, input);
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.(groupSelector + ' button[data-sw-quantity]');
    if (!button || button.disabled) return;
    const group = button.closest(groupSelector);
    const input = quantityInput(group);
    if (!input) return;
    const { minimum, increment, maxAdd } = constraints(group, input);
    const amount = Number(button.dataset.swQuantity);
    if (
      input.disabled || group.dataset.swAvailable !== 'true' || !Number.isInteger(amount) ||
      amount < minimum || (amount - minimum) % increment !== 0 ||
      amount > maxAdd
    ) return;

    const selector = input.closest('quantity-selector-component');
    if (typeof selector?.setValue === 'function') selector.setValue(String(amount));
    else input.value = String(amount);

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    // Native Horizon component notifies the product form and sticky ATC.
    selector?.onQuantityChange?.();
    selector?.updateButtonStates?.();
    refresh(group, input);
  });

  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches?.(inputSelector)) return;
    const group = input.closest('form')?.querySelector(groupSelector);
    if (group) refresh(group, input);
  });

  document.addEventListener('quantity-selector:update', event => {
    const group = event.target.closest('form')?.querySelector(groupSelector);
    const input = group && quantityInput(group);
    if (input) refresh(group, input);
  });

  document.addEventListener('variant:update', event => {
    const section = event.target.closest?.('.shopify-section, dialog');
    const updated = event.detail?.data?.html;
    if (!section || !updated) return;

    const form = section.querySelector('product-form-component form');
    const nextForm = updated.querySelector('product-form-component form');
    if (!form || !nextForm) return;

    const current = form.querySelector(groupSelector);
    const next = nextForm.querySelector(groupSelector);
    if (current && next) current.replaceWith(next.cloneNode(true));
    else if (current) current.remove();
    else if (next) {
      const anchor = form.querySelector('.quantity-selector-wrapper');
      anchor?.insertAdjacentElement('beforebegin', next.cloneNode(true));
    }

    // Shopify's server-rendered variant contains the correct quantity already in the cart.
    // Sync it even when native quantity-rule changes do not trigger a cart refresh.
    const nextInput = nextForm.querySelector(inputSelector);
    const input = form.querySelector(inputSelector);
    const selector = input?.closest('quantity-selector-component');
    if (nextInput && input) {
      input.disabled = nextInput.disabled;
      if (selector) {
        const nextSelector = nextInput.closest('quantity-selector-component');
        if (nextSelector?.dataset.variantId) selector.dataset.variantId = nextSelector.dataset.variantId;
        const inCart = Math.max(0, Number(nextInput.dataset.cartQuantity) || 0);
        if (typeof selector.setCartQuantity === 'function') selector.setCartQuantity(inCart);
        else input.dataset.cartQuantity = String(inCart);
      }
    }
    refreshAll(section);
  });

  // The native product form updates data-cart-quantity on cart:update.
  document.addEventListener('cart:update', () => queueMicrotask(() => refreshAll(document)));
  document.addEventListener('shopify:section:load', event => refreshAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refreshAll(document), { once: true });
  } else refreshAll(document);
})();